import { EntityReportTab, ENTITY_REPORT_VARIANT } from 'components/EntityReportTab';

export const ReportTab = ({ building, onNavigateToApplications }) => (
  <EntityReportTab
    variant={ENTITY_REPORT_VARIANT.COMPANY_LANDLORD_FULL}
    building={building}
    onNavigateToApplications={onNavigateToApplications}
    onApplicationsDrilldown={onNavigateToApplications}
  />
);
